import { TOGGLE_MODAL } from './action-types'

export const toggleModal = (id, data = {}) => {
  return {
    type: TOGGLE_MODAL,
    payload: { id, data }
  }
}
